// PageHeader - Shared page header component for consistent title formatting across all pages
// Standardizes: <h1>, text-xl font-semibold text-gray-900, mobile styling

import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  isMobile?: boolean;
  children?: ReactNode;
}

export function PageHeader({ title, isMobile = false, children }: PageHeaderProps) {
  return (
    <div className={`flex items-center justify-between ${isMobile ? 'bg-white border-b border-gray-200 -mx-4 px-4 pb-4' : ''}`}>
      <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
      {children}
    </div>
  );
}
